import { html } from '@utils/rendering/html';

import Card from '@shared/components/cards/default-cards';
import Button from '@shared/components/buttons';
import { StaticCardTypes } from '@shared/components/cards/card-types';

import ApiKeysTable from './api-keys-table';
import { useCallback } from 'preact/hooks';
import { useApiKeysContext } from './context/api-keys.context';

export default function ApiKeys({ selectedSystem, remoteSystemId }) {
    const { handleGenerateKey, isSubmitting } = useApiKeysContext();

    const onGenerateClicked = useCallback(() => {
        if (handleGenerateKey) {
            handleGenerateKey(remoteSystemId);
        }
    }, [handleGenerateKey, remoteSystemId]);

    return html`
        <${Card}
            header=${{
                title: 'API Keys Management',
                options: {
                    custom: html` <${Button}
                        label=${{ text: 'Generate New Key' }}
                        buttonType="secondary"
                        disabled=${isSubmitting}
                        onClick=${onGenerateClicked}
                    />`,
                },
            }}
            content=${{
                type: StaticCardTypes.other,
            }}>
                <${ApiKeysTable}
                    remoteSystemId=${remoteSystemId}
                />
        </${Card}>
    `;
}
